import { FormField } from 'ui/formField';
import { CheckboxField, LabelWithLink } from 'modules/templateEditor/common';
import { PushContentDefinition } from 'modules/graphql/types';

import { SettingsReadOnlyText } from '../../common/EditorContentContainer.styled';
import { getIsEditMode } from '../../common/utils';
import { SETTINGS_DISPLAY_CONTENT } from '../constants';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useQueryParamContext } from '../../context/QueryParamContext';

/*
  A component used to select the silent delivery option
  for Push templates.
*/
export const DeliverSilently = () => {
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const { isSilentPush } = (liveTemplate?.mediumData || {}) as PushContentDefinition;
  const isEditModeVisible = getIsEditMode(view, isEditMode);
  const readOnlyText = isSilentPush ? 'On' : 'Off';

  return (
    <FormField isHorizontalLayout labelText={SETTINGS_DISPLAY_CONTENT.deliverSilently.labelText}>
      {isEditModeVisible ? (
        <CheckboxField
          data-test="push-settings-check-silent-delivery"
          label={
            <LabelWithLink
              text={SETTINGS_DISPLAY_CONTENT.deliverSilently.checkboxLabel}
              url={SETTINGS_DISPLAY_CONTENT.deliverSilently.helpLink.link}
              openInNewTab
              linkSize="body2"
            />
          }
          status={isSilentPush}
          onClick={() => setCurrentMediumField('isSilentPush', !isSilentPush)}
        />
      ) : (
        <SettingsReadOnlyText data-test="deliver-silently-on-off" isUnset={!isSilentPush}>
          {readOnlyText}
        </SettingsReadOnlyText>
      )}
    </FormField>
  );
};
